var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('ExpiringImage',{attrs:{"src":_vm.src,"record-id":_vm.model.id,"url-key":_vm.urlKey,"fallback":_vm.defaultImageSrc}}):_c('img',{attrs:{"src":_vm.defaultImageSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }